const my_profile = {
  viewMyClubSeacretProfile: "Bekijk mijn ClubSeacret-profiel", // translated
  unverifiedEmail: "Niet-geverifieerde e-mail", // translated
  verifiedEmail: "Geverifieerde e-mail", // translated
  viewMoreDetails: "Bekijk meer details", // translated
};

export default my_profile;
